<!-- Step: VERIFICATION -->
<div>
  <h2 class="fdk-type-heading-2 text-fdk-primary text-center mt-fdk-xxxl">
    Enter the code we emailed you
  </h2>
  <p
    id="verification-hint"
    class="fdk-type-paragraph text-fdk-secondary mt-fdk-xs"
  >
    We sent a code to <span>{{ currentEmail }}</span
    >. It will expire in
    <span
      id="verification-countdown"
      class="fdk-type-label-large text-fdk-secondary"
      >{{ timeRemaining$ | async | date: "mm:ss" }}</span
    >.
  </p>

  <div class="flex justify-center space-x-2 mt-fdk-m" id="verification-inputs">
    <code-input
      [isCodeHidden]="false"
      [isPrevFocusableAfterClearing]="false"
      [codeLength]="6"
      (codeCompleted)="onCodeCompleted($event)"
    >
    </code-input>
  </div>

  <div *ngIf="errorMsg" class="mt-fdk-m">
    <fdk-alert
      title="That code didn't work"
      [description]="errorMsg"
      variant="error"
    />
  </div>

  <div class="mt-fdk-m text-center">
    <fdk-button
      id="resend-code"
      type="button"
      variant="secondary"
      [disabled]="!canResendCode || resendLoading || loading"
      (click)="onResendCode()"
    >
      {{
        canResendCode
          ? "Resend code"
          : "Resend code in " + resendSecondsRemaining + "s"
      }}
    </fdk-button>
  </div>

  <app-dev-tools
    *ngIf="canSkipSignInCode"
    [showSkip]="true"
    skipTooltip="Continue without entering the test authentication code."
    (skip)="skipSignInCode()"
  >
  </app-dev-tools>
</div>
<!-- End Step: VERIFICATION -->
